import { User } from '../../user/user.model';
import { CoachingCoverageContext } from '../coaching-coverage/coaching-coverage.model';
import { FLOAPerson } from '../oa/models/floa.model';

import {
    defaultInsightsSummaryDataKpi,
    InsightsSummaryDataKpi,
} from './model/insights-summary-data-kpi.model';
import {
    defaultInsightsSummaryDataPeriodTypes,
    InsightsSummaryDataPeriodTypes,
} from './model/insights-summary-data-period-types.model';
import { InsightsSummaryData } from './model/insights-summary-data.model';

export interface RootState {
    pending: {
        reload?: boolean;
    };

    // TODO revise. this is temporary means of flushing tabs after auth user has changed
    authUserId?: number;

    didInit?: boolean;
    insightSummaryData?: InsightsSummaryData;
    selectedPeriodType?: InsightsSummaryDataPeriodTypes;
    selectedKpi?: InsightsSummaryDataKpi;
    user?: User;
    userImage?: string;
    coverageContext?: CoachingCoverageContext;
    oaUser?: FLOAPerson;
}

export const defaultState = (): RootState => ({
    pending: {},
    selectedPeriodType: defaultInsightsSummaryDataPeriodTypes(),
    selectedKpi: defaultInsightsSummaryDataKpi(),
});
